import { render, staticRenderFns } from "./order.vue?vue&type=template&id=c60ee472&scoped=true&"
import script from "./order.js?vue&type=script&lang=js&"
export * from "./order.js?vue&type=script&lang=js&"
import style0 from "./order.css?vue&type=style&index=0&id=c60ee472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60ee472",
  null
  
)

export default component.exports